var moduleMap = {
	"./FileMgmtRoutes": () => {
		return Promise.all(/* __federation_expose_FileMgmtRoutes */[__webpack_require__.e(805), __webpack_require__.e(327), __webpack_require__.e(798), __webpack_require__.e(467), __webpack_require__.e(366), __webpack_require__.e(364), __webpack_require__.e(683)]).then(() => (() => ((__webpack_require__(48589)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};


// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});